module.exports = __webpack_public_path__ + "static/media/2lg.2e7fe4c1.jpg";